import styled, { css } from 'styled-components';
import { devices } from './landing-page-breakpoints/breakpoints';
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  justifyContentSpaceEvenly,
} from 'shared/styles/commonStyles';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addUserInfo, handleAccessToken } from 'shared/slice/userSlice';
import { useMutation } from 'react-query';
import { loginService, resetPasswordService } from 'shared/services';
import { NOT_ALLOWED_ROLES } from 'shared/constants';

const LoginBox = ({ isEnglish }) => {
  const navigation = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const invalidCredentialsMessage = isEnglish
    ? 'invalid username or password'
    : "Nom d'utilisateur ou mot de passe invalide";
  const emptyUsernameMessage = isEnglish
    ? 'Enter the Username'
    : "Entrez le nom d'utilisateur";
  const forgotPasswordMessage = isEnglish
    ? 'forgot your password?'
    : 'Mot de passe oublié?';
  const resetPasswordInstruction = isEnglish
    ? 'enter your account name to reset password'
    : 'Entrez votre nom de compte pour réinitialiser le mot de passe.';

  const isUserNotAllowed=(user)=>{
    return NOT_ALLOWED_ROLES.includes(user.user_role);
  }
  const { mutate: mutateLogin } = useMutation(loginService, {
    onSuccess: (data) => {
      if (data?.token) {
        if(isUserNotAllowed(data.user)){
          alert('You are not allowed to login');
          return;
        }
        localStorage.setItem('access_token', data.token);
        localStorage.setItem("loginTime", new Date());
        dispatch(handleAccessToken(data.token));
        dispatch(addUserInfo(data.user));
        navigation('/');
      } else {
        setErrorMessage(invalidCredentialsMessage);
      }
    },
    onError: () => {
      setErrorMessage(invalidCredentialsMessage);
    },
  });
  const { mutate: mutateResetPassword } = useMutation(resetPasswordService);
  const dispatch = useDispatch();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [resetAccount, setResetAccount] = useState('');
  const [displayResetPasswordBox, setDisplayResetPasswordBox] = useState(false);

  useEffect(() => {
    const storedUsername = localStorage.getItem('rememberedUsername');

    if (storedUsername) {
      setUsername(storedUsername);
      setRemember(true);
    }
  }, []);

  const handleRememberChange = (event) => {
    setRemember(event.target.checked);
    if (event.target.checked) {
      localStorage.setItem('rememberedUsername', username);
    } else {
      localStorage.removeItem('rememberedUsername');
    }
  };

  const handleUserNameChange = (e) => {
    setUsername(e.target.value);
    setErrorMessage('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrorMessage('');
  };

  useEffect(() => {
    if (remember) {
      localStorage.setItem('rememberedUsername', username);
    }
  }, [username, remember]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!username.trim()) {
      setErrorMessage(emptyUsernameMessage);
      return;
    }

    mutateLogin({ username, password, remember });
  };

  const handleDisplayResetPasswordBox = () => {
    setErrorMessage('');
    setDisplayResetPasswordBox((isDisplayed) => !isDisplayed);
  };

  const handleResetPassword = (e) => {
    e.preventDefault();

    if (!resetAccount.trim()) {
      setErrorMessage(emptyUsernameMessage);
      return;
    }

    mutateResetPassword(resetAccount.trim());
  };

  const loginForm = (
    <Form onSubmit={handleSubmit}>
      <InputWrapper>
        <Input
          type='text'
          placeholder='account name'
          value={username}
          onChange={handleUserNameChange}
        />
      </InputWrapper>
      <InputWrapper>
        <Input
          type='password'
          placeholder='password'
          value={password}
          onChange={handlePasswordChange}
        />
      </InputWrapper>
      <InputWrapper isCheckBox={true}>
        <Input
          isCheckBox={true}
          type='checkbox'
          checked={remember}
          onChange={handleRememberChange}
        />
        <P>{isEnglish ? 'remember my account name' : 'Mémoriser mon mot de passe'}</P>
      </InputWrapper>
      <Button type='submit'>
        <P>{isEnglish ? 'enter' : 'entrer'}</P>
      </Button>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Form>
  );

  const resetForm = (
    <ResetPasswordForm id='forgot-password-form' onSubmit={handleResetPassword}>
      <ResetPasswordInstruction>
        {resetPasswordInstruction}
      </ResetPasswordInstruction>
      <InputWrapper>
        <Input
          type='text'
          placeholder={isEnglish ? 'account name' : 'nom de compte'}
          value={resetAccount}
          onChange={(e) => {
            setResetAccount(e.target.value);
            setErrorMessage('');
          }}
        />
      </InputWrapper>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <Button type='submit'>
        <P>{isEnglish ? 'send' : 'envoyer'}</P>
      </Button>
    </ResetPasswordForm>
  );

  return (
    <Wrapper>
      <FlexWrapper>
        <Title>login</Title>
        {displayResetPasswordBox ? resetForm : loginForm}
        <A
          type='button'
          aria-expanded={displayResetPasswordBox}
          aria-controls='forgot-password-form'
          onClick={handleDisplayResetPasswordBox}
        >
          {displayResetPasswordBox
            ? isEnglish
              ? 'back to login'
              : 'retour à la connexion'
            : forgotPasswordMessage}
        </A>
      </FlexWrapper>
    </Wrapper>
  );
};

export default LoginBox;











































const Wrapper = styled.div`
  max-width: 432px;

  height: 454px;

  background: transparent linear-gradient(180deg, #233a544d 0%, #060d19 100%);
  box-shadow: inset 0px 0px 2px #ffffff7a, 0px 0px 3px #000000;
  border: 0.5px solid #000000;
  border-radius: 12px;
  ${flexBoxCenter}

  @media only screen and ${devices.mm} {
    max-width: 412px;
  }
`;

const FlexWrapper = styled.div`
  width: 100%;
  height: 380px;
  ${justifyContentSpaceBetween}
  flex-direction: column;
`;

const Title = styled.p`
  font-size: 16px;
  letter-spacing: 1.6px;
`;

const Form = styled.form`
  width: 372px;
  height: 318px;
  ${justifyContentSpaceEvenly}
  flex-direction: column;
`;

const ResetPasswordForm = styled.form`
  width: 100%;
  max-width: 372px;
  min-height: 220px;
  padding: 20px;
  box-sizing: border-box;
  ${justifyContentSpaceEvenly}
  flex-direction: column;
`;

const ResetPasswordInstruction = styled.p`
  margin: 0;
  font-size: 12px;
  letter-spacing: 1.2px;
  text-align: center;
`;

const InputWrapper = styled.div`
  ${({ isCheckBox }) =>
    isCheckBox
      ? css`
          width: 278px;
          height: 16px;

          ${justifyContentSpaceBetween}
          border-bottom:none;
        `
      : css`
          width: 332px;
          height: 20px;
          border-bottom: 1px solid #b4b4b4;
        `}
`;

const Input = styled.input`
  ${({ isCheckBox }) =>
    isCheckBox
      ? css`
          width: 10px;
          height: 10px;
        `
      : css`
          width: 100%;
          height: 100%;
          background-color: transparent;
          font-size: 12px;
          text-align: left;
          &::placeholder {
            color: #b4b4b4;
            text-align: left;
          }
        `}
`;

const Button = styled.button`
  width: 208px;
  height: 29px;

  background: transparent linear-gradient(180deg, #3fb6e0 0%, #1f67be 100%);
  box-shadow: inset 0px 0px 1px #ffffffed, 0px 0px 2px #000000;
  border: 0.5px solid #000000;
  border-radius: 6px;

  ${flexBoxCenter}
`;

const P = styled.p`
  font-size: 12px;
  letter-spacing: 1.2px;
`;

const ErrorMessage = styled.p`
  color: #ff6b6b;
  font-size: 12px;
  letter-spacing: 0.8px;
  text-align: center;
`;

const A = styled.button`
  cursor: pointer;
  min-height: 44px;
  padding: 8px;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 12px;
  letter-spacing: 1.2px;
`;
